<template>
  <v-col v-if="services">
    <v-card
        class="pa-2"
        outlined
        tile
    >
      <h2 class="subtitle-1">Services</h2>
      <v-list two-line>
        <v-list-item v-for="(status, service) in services" :key="service">
          <v-list-item-content>
            <v-list-item-title>{{ status }}</v-list-item-title>
            <v-list-item-subtitle>{{ service }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "service",
  props: {
    services: {
      required: true,
      type: Object,
    }
  }
}
</script>
